import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { NoteService } from '../../services/note/note.service';
import { ValidationService } from '../../services/validation/validation.service';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'pcm-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['../user-login/user-login.component.scss']
})

export class ResetPasswordComponent implements OnInit {
	@Input() isLoggedOutVersion = false;

	username: any = '';
	password = '';
	passwordConfirm = '';
	oldPassword: any = '';
	passwordMinimumLength = 15;

	ssoURLs: any = {};
	env = environment;

	constructor(
		public userService: UserService,
		public noteService: NoteService,
		public validationService: ValidationService
	) { }

	ngOnInit() {
		this.userService.checkCookies();
		// this.userService.selectDefaultTab(this.userService.tabsData.tabs);
		this.ssoURLs = this.userService.getSSOLoginURL(encodeURIComponent(window.location.origin));
	}

	submitLogin() {
		if (this.userService.isForgotPassword) {
			this.userService.forgotPassword({'email': this.username});
		} else {
			this.userService.changePassword({'email': this.username, 'password': this.password, 'oldpassword': this.oldPassword});
		}
	}

	disableReset() {
		const disabled =
			(!this.userService.isForgotPassword && this.passwordConfirm !== this.password) ||
			!this.isValidEmail(this.username) ||
			(this.isValidEmail(this.username) && this.username.trim().toLowerCase().endsWith('ibm.com'));
		return disabled;
	}

	isValidEmail(email) {
		if (!email) {
			return false;
		} else {
			email = email.trim().toLowerCase();
		}

		if (email.match(this.validationService.getPattern('email'))) {
			return true;
		}
	}

	getSSOurl(username) {
		if (!username) {
			return '';
		} else {
			const name = this.userService.formatUserName(username);
			if (name.endsWith('ibm.com')) {
				return this.ssoURLs.IBM;
			}
		}
	}

	getSSOBtnText(username) {
		if (!username) {
			return '';
		} else {
			const name = this.userService.formatUserName(username);
			if (name.endsWith('ibm.com')) {
				return 'IBMid';
			}
		}
	}

	onCloseNote() {
		this.noteService.currentNote.active = false;
	}
}
